export interface TrajectoryAnimationState {
  flightProgress: number;
  bloomProgress: number;
  finished: boolean;
}

export const throwDurationMs = 600;
export const bloomDurationMs = 450;
export const utilityAnimationDurationMs = throwDurationMs + bloomDurationMs;

export function trajectoryAnimationState(
  elapsedMs: number,
  flightDurationMs: number,
  bloomDurationMs: number,
): TrajectoryAnimationState {
  if (
    !Number.isFinite(elapsedMs) ||
    !Number.isFinite(flightDurationMs) ||
    !Number.isFinite(bloomDurationMs) ||
    flightDurationMs <= 0 ||
    bloomDurationMs <= 0
  ) {
    throw new RangeError("trajectory animation durations must be positive");
  }
  const elapsed = Math.max(0, elapsedMs);
  const flightProgress = Math.min(1, elapsed / flightDurationMs);
  const bloomProgress = Math.min(
    1,
    Math.max(0, (elapsed - flightDurationMs) / bloomDurationMs),
  );
  return {
    flightProgress,
    bloomProgress,
    finished: bloomProgress >= 1,
  };
}
